import React from 'react'
import { createTeleporter } from '../Teleporter';

const Title = createTeleporter();

export const TitleTarget = () => {
  return <Title.Target as="div" />
}

export const TitleSource = ({ children }) => {
  return (
    <Title.Source>{children}</Title.Source>
  );
}